export default __webpack_public_path__ + "80fa434e0c65299480a603874b82dc0d.png";